export default "__VITE_ASSET__lIu1Hg5p__"